"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = exports.isNextTo8 = exports.isNextTo8Obj = exports.isSameSpot = exports.isSameSpotObj = exports.moveTileOffset = exports.moveTile = exports.moveTileObj = exports.screenHeight = exports.screenWidth = exports.sizeY = exports.sizeX = exports.scale = void 0;
exports.scale = 0.5;
exports.sizeX = 16 * 2;
exports.sizeY = 16 * 2;
exports.screenWidth = 40;
exports.screenHeight = 23;
var moveTileObj = function (image, obj) {
    image.x = obj.x * exports.sizeX;
    image.y = obj.y * exports.sizeY;
};
exports.moveTileObj = moveTileObj;
var moveTile = function (image, x, y) {
    image.x = x * exports.sizeX;
    image.y = y * exports.sizeY;
};
exports.moveTile = moveTile;
var moveTileOffset = function (image, x, y, ox, oy) {
    image.x = x * exports.sizeX + ox * exports.sizeX;
    image.y = y * exports.sizeY + oy * exports.sizeY;
};
exports.moveTileOffset = moveTileOffset;
var isSameSpotObj = function (a, b) {
    return a.x === b.x && a.y === b.y;
};
exports.isSameSpotObj = isSameSpotObj;
var isSameSpot = function (x1, y1, x2, y2) {
    return x1 === x2 && y1 === y2;
};
exports.isSameSpot = isSameSpot;
var isNextTo8Obj = function (a, b) {
    return Math.abs(a.y - b.y) <= 1 && Math.abs(a.x - b.x) <= 1;
};
exports.isNextTo8Obj = isNextTo8Obj;
var isNextTo8 = function (x1, y1, x2, y2) {
    return Math.abs(y1 - y2) <= 1 && Math.abs(x1 - x2) <= 1;
};
exports.isNextTo8 = isNextTo8;
// https://lospec.com/palette-list/japanese-woodblock#comments
exports.colors = {
    none: -1,
    dark: 0x2b2821,
    brown: 0x624c3c,
    peach: 0xd9ac8b,
    light: 0xe3cfb4,
    darkBlue: 0x243d5c,
    blueGray: 0x5d7275,
    lightBlue: 0x5c8b93,
    gray: 0xb1a58d,
    red: 0xb03a48,
    orange: 0xd4804d,
    yellow: 0xe0c872,
    green: 0x3e6958,
    pureBlack: 0x000000,
    pureWhite: 0xffffff,
};
